import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitch.css';

const LanguageSwitch = ({ compact = false, showLabel = true, variant }) => {
    const { getCurrentLanguage, changeLanguage, getAvailableLanguages } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const currentLanguage = getCurrentLanguage();
    const availableLanguages = getAvailableLanguages();
    const currentLangData = availableLanguages.find(lang => lang.code === currentLanguage);

    const handleLanguageChange = (langCode) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    // Variante de la nouvelle charte : codes de langue (les drapeaux emoji ne s'affichent pas sous Windows)
    if (variant === 'c2') {
        return (
            <div className="c2-lang">
                <button
                    type="button"
                    className="c2-lang__button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-haspopup="true"
                    aria-expanded={isOpen}
                    title={currentLangData?.name}
                >
                    {currentLanguage.toUpperCase()}
                </button>
                {isOpen && (
                    <div className="c2-lang__menu">
                        {availableLanguages.map(lang => (
                            <button
                                key={lang.code}
                                type="button"
                                className={`c2-lang__option${lang.code === currentLanguage ? ' is-active' : ''}`}
                                onClick={() => handleLanguageChange(lang.code)}
                            >
                                <span className="c2-lang__code">{lang.code.toUpperCase()}</span>
                                {lang.name}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    if (compact) {
        return (
            <div className="language-switch-compact">
                <button 
                    className="language-button-compact"
                    onClick={() => setIsOpen(!isOpen)}
                    title={currentLangData?.name}
                >
                    {currentLangData?.flag}
                </button>
                {isOpen && (
                    <div className="language-dropdown-compact">
                        {availableLanguages.map(lang => (
                            <button
                                key={lang.code}
                                className={`language-option-compact ${lang.code === currentLanguage ? 'active' : ''}`}
                                onClick={() => handleLanguageChange(lang.code)}
                                title={lang.name}
                            >
                                {lang.flag}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="language-switch">
            <button 
                className="language-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="language-flag">{currentLangData?.flag}</span>
                {showLabel && <span className="language-name">{currentLangData?.name}</span>}
                <span className="language-arrow">{isOpen ? '▲' : '▼'}</span>
            </button>
            {isOpen && (
                <div className="language-dropdown">
                    {availableLanguages.map(lang => (
                        <button
                            key={lang.code}
                            className={`language-option ${lang.code === currentLanguage ? 'active' : ''}`}
                            onClick={() => handleLanguageChange(lang.code)}
                        >
                            <span className="language-flag">{lang.flag}</span>
                            <span className="language-name">{lang.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitch;
